import { runDemo } from "../shared/demoRunner";
import { createInstancesTestScene } from "./scene";

runDemo({ createScene: createInstancesTestScene });
